import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_PDF: createAsyncActionConstants('FETCH_PDF'),
    RESET_PDF: createAsyncActionConstants('RESET_PDF'),
    RESEND_MESSAGE: createAsyncActionConstants('RESEND_MESSAGE'),
}